/* The Christmas Cart: tree bundle. Running total, quantity buttons, tree add-on, add everything ticked to the cart. */
(function () {
  if (window.__tccBundle) return;
  window.__tccBundle = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Same as tcc-inspiration.js: add, then let the theme's cart drawer refresh and open.
  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-ajax' })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: json } }));
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        return cart;
      });
  }

  function initBundle(w) {
    if (w.__tccInit) return;
    w.__tccInit = true;
    var threshold = +w.dataset.threshold * 100;
    var tree = w.querySelector('[data-tree]');
    var btn = w.querySelector('[data-add]');
    var msg = w.querySelector('[data-msg]');
    function rows() { return [].slice.call(w.querySelectorAll('.tcc-blist input[data-variant]')); }
    function qtyOf(i) { return +i.closest('label').querySelector('[data-qty] b').textContent; }

    function update() {
      var sum = 0, n = 0, pieces = 0;
      rows().forEach(function (i) {
        var q = qtyOf(i), line = +i.dataset.price * q;
        i.closest('label').querySelector('[data-line]').textContent = money(line);
        i.closest('li').classList.toggle('is-off', !i.checked);
        if (i.checked) { sum += line; n++; pieces += q; }
      });
      var withTree = tree && tree.checked;
      if (withTree) sum += +tree.dataset.price;
      w.querySelector('[data-total]').textContent = money(sum);
      w.querySelector('[data-summary]').textContent = pieces + ' pieces' + (tree ? (withTree ? ' plus the tree' : ' \u00b7 tree not included') : '');
      w.querySelector('[data-bar]').style.width = Math.min(100, threshold ? (sum / threshold) * 100 : 100) + '%';
      w.querySelector('[data-ship]').innerHTML = sum >= threshold
        ? '<strong style="color:var(--tcc-ok)">\u2713 Free standard shipping unlocked</strong>'
        : 'Add ' + money(threshold - sum) + ' more for free shipping';
      btn.disabled = !(n || withTree);
    }

    w.addEventListener('change', update);
    w.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty] button');
      if (!b) return;
      e.preventDefault();
      var label = b.closest('label'), input = label.querySelector('input');
      if (input.disabled) return;
      var v = b.parentNode.querySelector('b');
      v.textContent = Math.max(1, +v.textContent + (b.getAttribute('aria-label') === 'More' ? 1 : -1));
      input.checked = true;
      update();
    });

    btn.addEventListener('click', function () {
      var items = [];
      rows().forEach(function (i) { if (i.checked) items.push({ id: +i.dataset.variant, quantity: qtyOf(i) }); });
      if (tree && tree.checked) items.push({ id: +tree.dataset.variant, quantity: 1 });
      if (!items.length) return;
      btn.disabled = true;
      msg.textContent = 'Adding your bundle\u2026';
      addToCart(items)
        .then(function () { msg.textContent = 'Your bundle is in the cart.'; })
        .catch(function (err) { msg.textContent = (err && err.description) || 'Something went wrong. Please try again.'; })
        .finally(function () { btn.disabled = false; });
    });
    update();
  }

  function init(scope) { (scope || document).querySelectorAll('[data-tcc-bundle]').forEach(initBundle); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
